@if (showSideMenu()) {
  <app-side-menu class="fixed top-0 h-screen w-[175px] md:z-[51] md:w-auto md:shadow-default" />
}
<div class="flex w-full flex-col overflow-x-hidden sm:ml-0" [ngClass]="{ 'ml-[175px] md:ml-[56px]': showSideMenu() }">
  <router-outlet />
</div>
@if (versions(); as versions) {
  <app-versions [versions]="versions" [showOnlyFeVersion]="showOnlyFeVersion" />
}
